import React from 'react';

import { Box, CardMedia, Typography } from '@mui/material';

import styled from '@emotion/styled';

import { Offer, OfferCategory, OfferStatus } from '../../../../graphql/API';
import Icons from '../../../../themes/icons';
import Highlight from '../../../../pages/Offer/components/Highlight';

type Props = {
  offer: Offer;
  selected?: boolean;
  onSelection?: () => void;
};

export const OfferCard: React.FC<Props> = ({
  offer,
  selected = false,
  onSelection,
}) => {
  return (
    <Container selected={selected} onClick={onSelection}>
      <Highlight
        privateOffer={!!offer.private}
        eventOffer={offer.category === OfferCategory.event}
        status={offer.status}
      />
      <Box sx={{ position: 'relative', borderRadius: '12px', overflow: 'hidden' }}>
      <CardMedia
        component={'img'}
        src={String(offer.picture?.medium)}
        width={'100%'}
        height={175}
        loading='lazy'
        onError={(e) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-expect-error
          e.target.src = String(offer?.picture?.small) || '';
        }}
        sx={{ objectFit: 'cover' }}
        />
        {offer.status === OfferStatus.pending && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 239, 150, 0.5)',
            }}
          />
        )}
      </Box>
      <Typography
        sx={{
          fontFamily: 'Poppins',
          fontSize: '15px',
          px: 1.5,
          pt: 1.5,
          pb: 4,
          fontWeight: selected ? 500 : 400,
        }}
      >
        {offer?.title}
      </Typography>
      {selected && (
        <Box sx={{ position: 'absolute', right: '18px', top: '10px' }}>
          <Icons.SelectedTickIcon />
        </Box>
      )}
    </Container>
  );
};

const Container = styled.div<{ selected?: boolean }>`
  background-color: #fff;
  border-radius: 12px;
  border: ${(props) => (props.selected ? '2px solid #765BC6' : '1px solid #efeeee')};

  position: relative;
  overflow: hidden;
  cursor: pointer;
`;
